import {ESBA_DATE_FORMAT} from "../../../common";
import DatePicker, {ReactDatePickerProps} from "react-datepicker";
import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {parseISO} from "date-fns";
import {PractitionerCareTeamInput} from "../domain";
import {CustomDateInput} from "../../component/CustomDateInput";

type CareTeamStartDateInputProps = {
    sending: boolean;
} & Omit<ReactDatePickerProps, 'onChange'>;
export const PractitionerCareTeamStartDateInput = memo(({
                                                sending,
                                                ...datePickerProps
                                            }: CareTeamStartDateInputProps) => {
    const {
        control,
        formState: {
            errors
        },
    } = useFormContext<PractitionerCareTeamInput>();

    return (
        <li className="w-full flex text-base items-center pb-2">
            <div className="w-2/6 text-right">
                Start Date
            </div>
            <Controller
                name='startDate'
                control={control}
                rules={{required: true}}
                render={({field: {onChange, onBlur, value: isoValueStr}}) => <DatePicker
                    wrapperClassName="w-3/6"
                    {...datePickerProps}
                    disabled={sending}
                    onChange={(newValue: Date | null) => onChange(newValue?.toISOString() || null)}
                    onBlur={onBlur}
                    selected={isoValueStr ? parseISO(isoValueStr) : undefined}
                    dateFormat={ESBA_DATE_FORMAT}
                    customInput={
                        <CustomDateInput
                            fieldName="startDate"
                            value={new Date().toISOString()}
                            errorMsg={errors.startDate ? "Required" : undefined}
                        />
                    }
                />}
            />
        </li>
    );
});
